import styled from 'styled-components';

export const TableContainer = styled.div`
	display: flex;
	flex-direction: column;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 4px;
	overflow: hidden;
	background: #fff;
	width: 100%;
	min-height: fit-content;
`;

export const Header = styled.div`
	display: flex;
	border-bottom: 1px solid #e0e0e0;
	z-index: 3;
`;

export const HeaderCell = styled.div<{ bgColor: string }>`
	flex: 1;
	position: relative;
	padding: 12px 0;
	display: flex;
	justify-content: center;
	align-items: flex-end;
	background: #fff;
	width: 100%;

	&::before {
		content: '';
		position: absolute;
		bottom: -1px;
		left: 0;
		width: 100%;
		height: 1px;
		background-color: ${(props) => props.bgColor};
	}
`;

export const Body = styled.div`
	display: flex;
	flex-direction: column;
`;
